module.exports = __webpack_public_path__ + "img/list3.b2639ac5.png";